var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedInColorfulIcon = function SvgLinkedInColorfulIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 22 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007EBB",
    fillRule: "evenodd",
    d: "M22 20h-4.862v-7.03c0-1.841-.76-3.097-2.433-3.097-1.28 0-1.991.847-2.322 1.664-.124.294-.105.702-.105 1.11V20H7.461s.062-12.454 0-13.586h4.817v2.132c.285-.933 1.824-2.263 4.28-2.263 3.048 0 5.442 1.954 5.442 6.162zM2.59 4.714h-.031C1.006 4.714 0 3.675 0 2.36 0 1.017 1.036 0 2.62 0 4.2 0 5.173 1.014 5.204 2.355c0 1.317-1.004 2.36-2.615 2.36m-2.035 1.7h4.288V20H.555z"
  })));
};
export default SvgLinkedInColorfulIcon;